import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
export var EnumHelper =
/*#__PURE__*/
function () {
  function EnumHelper() {
    _classCallCheck(this, EnumHelper);
  }

  _createClass(EnumHelper, [{
    key: "getAllNames",
    value: function getAllNames(T) {
      var enumNames = [];

      for (var key in T) {
        if (T.hasOwnProperty(key)) {
          enumNames.push(key);
        }
      }

      return enumNames;
    }
  }, {
    key: "getAllValues",
    value: function getAllValues(T) {
      var allEnumValues = Object.keys(T).map(function (key) {
        return T[key];
      });
      return allEnumValues;
    }
  }, {
    key: "getEnumFromValue",
    value: function getEnumFromValue(T, value) {
      try {
        if (!value) {
          return undefined;
        } // we can map back from index number directly


        if (this.isNumeric(value)) {
          return T[value];
        } // for strings, we need to compare each value separately


        var allEnumValues = this.getAllValues(T);
        var result = allEnumValues.find(function (m) {
          return m.toLowerCase() === value.toString().toLowerCase();
        });

        if (!result) {
          return undefined;
        }

        return result;
      } catch (err) {
        return undefined;
      }
    }
  }, {
    key: "getEnumFromName",
    value: function getEnumFromName(T, name) {
      var allNames = this.getAllNames(T);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = allNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var enumName = _step.value;

          if (enumName.toLowerCase() === name.toLowerCase()) {
            return T[enumName];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return undefined;
    }
  }, {
    key: "isNumeric",
    value: function isNumeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    }
  }]);

  return EnumHelper;
}();
export var enumHelper = new EnumHelper();